import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import RequestCard from "@/components/RequestCard";
import { AdSlot } from "@/components/AdSlot";
import { ADS_LIST_EVERY } from "@/config/ads";
import { useApp } from "@/context/AppContext";
import { usePageMeta } from "@/lib/seo";
import API from "@/lib/api";
import { ArrowLeft, Info } from "lucide-react";

export default function CategoryList() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { getCategory, catName } = useApp();
  const [items, setItems] = useState(null);
  const [sub, setSub] = useState("");
  const cat = getCategory(slug);
  usePageMeta(cat ? `Richieste: ${catName(cat)}` : null, cat?.description);

  useEffect(() => {
    setItems(null);
    API.get("/public/requests", { params: { category: slug, ...(sub ? { subcategory: sub } : {}) } })
      .then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [slug, sub]);

  const subs = cat?.subcategories || [];
  return (
    <Layout>
      <button onClick={() => navigate("/")} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Home</button>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-1">{cat ? catName(cat) : slug}</h1>
      {cat?.description && <p data-testid="category-description" className="text-sm text-[#2A2E48] mb-2 max-w-2xl">{cat.description}</p>}
      <p className="text-sm text-[#4A4E68] mb-4">Richieste aperte nella tua zona, le più vicine prima.</p>

      {subs.length > 0 && (
        <div data-testid="sub-filter" className="flex gap-2 overflow-x-auto no-scrollbar pb-1 mb-4">
          {[{ slug: "", label: "Tutte" }, ...subs.map((s) => ({ slug: s.slug, label: catName(s) }))].map((s) => (
            <button key={s.slug || "all"} data-testid={`sub-filter-${s.slug || "all"}`} onClick={() => setSub(s.slug)}
              className={`shrink-0 px-4 h-9 rounded-full text-sm font-bold transition-colors duration-150 ${sub === s.slug ? "bg-[#FFC400] text-[#0F1230]" : "bg-white text-[#0F1230] hover:text-[#1F4FE0]"}`}>
              {s.label}
            </button>
          ))}
        </div>
      )}

      {cat?.notice && (
        <div className="flex gap-2 bg-[#F2F2FB] border border-[#D8C7F0] rounded-xl p-3 mb-4 text-sm text-[#6B21A8]">
          <Info size={16} className="shrink-0 mt-0.5" /> <span>{cat.notice}</span>
        </div>
      )}

      {items === null ? (
        <p className="text-[#4A4E68]">Caricamento...</p>
      ) : items.length === 0 ? (
        <div data-testid="empty-category" className="bg-white rounded-[18px] border border-[#DADFEA] p-6 text-center">
          <p className="text-[#2A2E48] mb-3">Nessuna richiesta aperta in questa categoria.</p>
          <button data-testid="enlarge-zone-button" onClick={() => navigate("/")} className="bg-[#1F4FE0] text-white rounded-full px-5 h-11 font-medium">Torna alla home</button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((r, i) => (
            <React.Fragment key={r.id}>
              <RequestCard req={r} />
              {(i + 1) % ADS_LIST_EVERY === 0 && i < items.length - 1 && <AdSlot placement="list" category={slug} className="md:col-span-2 my-2" />}
            </React.Fragment>
          ))}
        </div>
      )}
    </Layout>
  );
}
